/**
 * Available tabs in the drawing widget.
 */
export enum DrawingTabEnum {
    ADD_PREDEFINED_SHAPE_TAB = 'ADD_PREDEFINED_SHAPE_TAB',
    FREE_DRAWING_TAB = 'FREE_DRAWING_TAB',
    /**
     * For any tab that belongs to a shape. This is not one tab but the symbol for any shape tab.
     */
    SELECTED_SHAPE_TAB = 'SELECTED_SHAPE_TAB',
    SHAPE_DROP_DOWN_BUTTON = 'SHAPE_DROP_DOWN_BUTTON',
}
